<!--

Switch component can accept multiple props to change the appearance and behaviour.

id:                 Id of the switch we want to operate. If multiple switches have the same id they will all be affected when one of them is switched.
height:             defines the height of a switch
value:              initial state
outline-color:      color of the switch outline
switch-color:       color of the switch
off-outline-color:  color of the switch outline when switch is off
off-switch-color:   color of the switch when switch is off
radius              border radius of the switch
gap                 gap between the switch and the outline
aspect              aspect ratio of the switch. width = height * aspect

TODO ::: props to set exact width and height. Size can stay and can be a primary dimension prop.

-->


<template>
  <div
    class="rounded-checkbox"
    :style="cssVars">
    <input
      :id="buttonID"
      v-model="checked"
      type="checkbox"
      class="rounded"
      @change="changeState">
    <label
      :for="buttonID"
      class="m-0"/>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import randomString from '@/helpers/randomString';

export default {
  name: 'SwitchCheckbox',
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
    height: {
      type: Number,
      default: 30,
    },
    value: {
      type: Boolean,
      default: false,
    },
    outlineColor: {
      type: String,
      default: SBColors.bluePrimary,
    },
    switchColor: {
      type: String,
      default: '#ffffff',
    },
    offOutlineColor: {
      type: String,
      default: '#b1b8c4',
    },
    offSwitchColor: {
      type: String,
      default: '#ffffff',
    },
    radius: {
      type: Number,
      default: 50,
    },
    gap: {
      type: Number,
      default: 3,
    },
    aspect: {
      type: Number,
      default: 1.55,
    },
  },
  data() {
    return {
      checked: this.value,
      randomId: randomString(),
      SBColors,
    };
  },
  computed: {
    cssVars() {
      return {
        '--outline-color': this.checked ? this.outlineColor : this.offOutlineColor,
        '--switch-color': this.checked ? this.switchColor : this.offSwitchColor,
        '--height': `${this.height}px`,
        '--radius': `${this.radius}px`,
        '--gap': `${this.gap}px`,
        '--aspect': `${this.aspect}`,
      };
    },
    buttonID() {
      return this.id ? this.id : this.randomId;
    },
  },
  watch: {
    value(value) {
      this.checked = value;
    },
  },
  methods: {
    changeState() {
      this.$emit('input', this.checked);
    },
  },
};
</script>

<style scoped>
.rounded-checkbox {
  position: relative;
  width: calc(var(--height) * var(--aspect));
  height: var(--height);

  label {
    width: 100%;
    height: 100%;
    border-radius: var(--radius);
    background-color: var(--outline-color)!important;

    &:after {
      width: calc(var(--height) - (var(--gap) * 2));
      height: calc(var(--height) - (var(--gap) * 2));
      border-radius: calc(var(--radius) - var(--gap));
      top: var(--gap);
      left: var(--gap);
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      background-color: var(--switch-color)!important;
    }
  }

  input[type=checkbox]:checked+label:after {
    left: calc(var(--height) * var(--aspect) - var(--height) + var(--gap));
  }
}
</style>
